import React from "react";

import MAGIC_LOADING from "../../../public/assets/magic_loading.gif";
import { SparklesLoader } from "../common/SparklesLoader";
import { useLoadingStore } from "../../stores/useLoadingStore";

const LoadingOverlay = () => {
  const { loading, magicLoading } = useLoadingStore();

  if (!loading) return null;

  if (magicLoading) {
    return (
      <div className="k-loader-mask" style={{ background: "transparent" }}>
        <img style={{ width: "15%" }} src={MAGIC_LOADING} />
      </div>
    );
  }

  return (
    <div
      className="k-loader-mask"
      role="status"
      aria-label="Loading"
      aria-live="polite"
    >
      <SparklesLoader label="" />
    </div>
  );
};

export default LoadingOverlay;
